module.exports = __webpack_public_path__ + "static/img/SX.a0ee9453.png";